import React, { FunctionComponent } from 'react'

import { ContentSectionCard } from 'components/TailwindUIToolkit'
import Grid from '../Grids/SystemWorkOrderGrid'
import { Spinner } from 'reactstrap'

type SystemWorkOrderHistoryPropTypes = {
  portfolioHomeId: string
}

const SystemWorkOrderHistory: FunctionComponent<
  React.PropsWithChildren<SystemWorkOrderHistoryPropTypes>
> = ({ portfolioHomeId }) => (
  <ContentSectionCard title='System Work Order History' staticSize>
    <React.Suspense fallback={<Spinner />}>
      <Grid portfolioHomeId={portfolioHomeId} warrantyFilter='all' serviceDateFilter='all' />
    </React.Suspense>
  </ContentSectionCard>
)

export default SystemWorkOrderHistory
